import * as React from 'react';
import * as Moment from 'moment-timezone';

export interface IDoomsdayExerciseProps {
  count: number;
  currentDate: Moment.Moment;
  points: number;
}

export default class DoomsdayExercise extends React.Component<IDoomsdayExerciseProps> {
  public render() {
    return (
      <div className="row">
        <div className="col" />
        <div className="col-sm-12 col-md-4">
          <h2 className="text-center">What day is this?&nbsp;<span className="badge badge-secondary" title="correct / all">{this.props.points} / {this.props.count}</span></h2>
          <h3 className="text-center mt-5 mb-5 text-white bg-dark">{this.props.currentDate.format("LL")}</h3>
        </div>
        <div className="col" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Doomsday/DoomsdayExercise.tsx